import AOS from 'aos';
import initializeMobileMenu from './menu';
//import WooCommerce from './woo'
import {checkboxStyle} from './utils/utils';
import frontpage from './frontpage';
import {Fancybox} from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';
import BlockAsariLatestOffers from './blocks/asari-latest-offers';
import BlockAsariOffers from './blocks/asari-offers';
import BlockAsariSearch from './blocks/asari-search';
import SingleOffer from './single-offer';

class App {
  constructor() {
    this.initialize();
  }

  initialize() {
    AOS.init( {
      disable: 'mobile',
      once: true,
      duration: 1000,
    } );
    initializeMobileMenu();
    checkboxStyle();
    frontpage();
    BlockAsariLatestOffers();
    BlockAsariOffers();
    BlockAsariSearch();
    SingleOffer();
    contactFormTopic();
    // const Woo = new WooCommerce();
    document.querySelectorAll( '.contact-buttons__button' ).
        forEach( function( item ) {
          item.addEventListener( 'click', function( e ) {
            contactFormTopic( item.href );
            console.log( item.href );
          } );
        } );

  }
}

function initializeApp() {
  const app = new App();
}

if (document.readyState === 'loading') {
  document.addEventListener( 'DOMContentLoaded', initializeApp );
} else {
  initializeApp();
}

function contactFormTopic( url ) {
  if (!url) {
    url = window.location.href;
  }
  var hash = url.substring( url.indexOf( '#' ) + 1 );
  var topicSelect = document.querySelector( 'select[name="topic"]' );
  var optionValue;

  if (hash && topicSelect) {
    if (hash === 'zglos-poszukiwanie') {
      optionValue = 'Zgłoś poszukiwanie';
    } else if (hash === 'zglos-nieruchomosc') {
      optionValue = 'Zgłoś nieruchomość';
    }

    for (var i = 0; i < topicSelect.options.length; ++i) {
      if (topicSelect.options[i].text === optionValue)
        topicSelect.options[i].selected = true;
    }
  }
}